import React, { useEffect } from 'react';
import config from '../../../config/config';
import FacilityESRIMap from './FacilityESRIMap';
import './esrimap.css';
import { map_message } from '@constants/esriMapConstant';
import { toast } from 'react-toastify';

const MapWrapper = (location: any) => {

    const handleErrorMessage = () => {
        toast.warning(map_message.mapConfigDisabled, {
            position: "top-center",
        });
    };

    useEffect(() => {
        if (config.enableArcGISMap !== 'ON') {
            handleErrorMessage();
        }
    }, []);

    return (
        <>
            {config.enableArcGISMap === 'ON' ? <><FacilityESRIMap {...location} /></> : <div className='mapDisableWrapperClass'>
                <p className='disableText'>Interactive map is disabled</p>
            </div>}
        </>

    );
};

export default MapWrapper;